import React from "react";

export default function navbar() {
	return (
		<div className="w-full mt-0 md:mt-4 mb-8 flex flex-row items-center rounded-md shadow-md border border-black justify-center">
			<a className="font-bold py-4" href="/">
				آووکادو - مدیریت کار های روزانه
				<span role="img" aria-label="avocado">
					🥑
				</span>
			</a>
		</div>
	);
}
